export enum CallTab {
  MY = 'my',
  TEAM = 'team',
}

export const callsTabs = [
  {
    id: CallTab.MY,
    name: 'My calls',
  },
  {
    id: CallTab.TEAM,
    name: 'Team calls',
  },
];

export enum InsertVariant {
  WITH_SUMMARY = 'with-summary',
  ONLY_VIDEO = 'only-video',
}
